import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { EventService } from '../../../services/event.service';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'wire-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AsyncPipe],
})
export class SidebarComponent {
  private readonly eventService = inject(EventService);
  event = this.eventService.currentEvent;

  getDateRange(startDate: Date, endDate: Date): string {
    const start = new Date(startDate);
    const month = start.toLocaleDateString('en-US', { month: 'long' });
    const year = start.getFullYear();
    return `${month.toUpperCase()} ${year}`;
  }
}
